<template>
<div>
    <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.deviceList.breadcrumb')}}
                </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <el-container style="border: 1px solid #eee">
        <el-aside :style="{ width: '200px', 'background-color': '#fff', height: leftHeight }">
            <div :style="{ height: leftTreeHeight, 'overflow-y': 'auto' }">
                <el-tree class="filter-tree" :data="deptTree" :props="defaultProps" :expand-on-click-node="false" node-key="id" default-expand-all ref="tree" style="height: 50px" @node-click="handleNodeClick" highlight-current></el-tree>
            </div>
        </el-aside>
        <el-main>
            <el-table :data="balances" border class="table" ref="multipleTable" :element-loading-text="$t('pages.deviceList.loading')" v-loading="loading" header-cell-class-name="table-header" @row-dblclick="dbSelected">
                <el-table-column type="index" width="50" :label="$t('pages.deviceList.index')"></el-table-column>
                <el-table-column prop="provinceCity" :label="$t('pages.deviceList.region')">
                    <template slot-scope="scope">{{ scope.row.provinceCity.replace('/','') }}</template>
                </el-table-column>
                <el-table-column prop="mineName" :label="$t('pages.deviceList.mineName')"></el-table-column>
                <el-table-column sortable prop="name" :label="$t('pages.deviceList.scaleName')"></el-table-column>

                <el-table-column :label="$t('pages.deviceList.viewInfo')" width="110" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="handleEdit(scope.row.id, scope.row,'DeviceList')">{{$t('pages.deviceList.viewStatus')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </el-main>
    </el-container>
</div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {
    SortField,
    toTree,
    getchild
} from '../../utils/helper';
import {
    quillEditor
} from 'vue-quill-editor';
import {
    RefreshToken
} from '../../api/Auth';
let that;
let roleArr = [];
export default {
    name: 'user',
    data: function () {
        const checkPass = (rule, value, callback) => {
            if (value !== this.user.Password) {
                callback(new Error('两次输入密码不一致！'));
            } else {
                callback();
            }
        };
        return {
            balances: [],
            UpdateRoleAndDept: false,
            deptArr: [],
            deptTree: [],
            headTitle: '',
            viewVisible: false,
            isadd: false,
            user: {},
            editVisible: false,
            users: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            roles: [],
            isResouceShow: 0,
            query: {
                Field1: '',
                Field2: '',
                Field3: '',
                Field5: '',
                PageIndex: 1,
                PageSize: 15
            },
            editorOption: {
                placeholder: '请输入内容！！！'
            },
            leftHeight: '',
            leftTreeHeight: '',
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            rules: {
                LoginId: [{
                        required: true,
                        message: this.$t('pages.deviceList.accountRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 15,
                        message: this.$t('pages.deviceList.lengthRange'),
                        trigger: 'blur'
                    }
                ],
                RealName: [{
                    required: true,
                    message: this.$t('pages.deviceList.nameRequired'),
                    trigger: 'blur'
                }],
                Password: [{
                        required: true,
                        message: this.$t('pages.deviceList.pwdSet'),
                        trigger: 'blur'
                    },
                    {
                        min: 5,
                        message: this.$t('pages.deviceList.pwdMin'),
                        trigger: 'blur'
                    }
                ],
                agapwd: [{
                        required: true,
                        message: this.$t('pages.deviceList.pwdConfirmRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 5,
                        message: '密码长度至少5位',
                        trigger: 'blur'
                    },
                    {
                        validator: checkPass,
                        message: this.$t('pages.deviceList.pwdMismatch'),
                        trigger: 'blur'
                    }
                ],
                UserType: [{
                    required: true,
                    message: this.$t('pages.deviceList.roleTypeRequired'),
                    trigger: 'blur'
                }],
                Phone: [{
                    required: true,
                    message: this.$t('pages.deviceList.phoneRequired'),
                    trigger: 'blur'
                }]
            }
        };
    },
    filters: {
        usertypeFormat(UserType) {
            var usertypeName = '';
            var item = roleArr.filter((t) => t.id == UserType);
            usertypeName = item.length > 0 ? item[0]['name'] : '';
            return usertypeName;
        }
    },
    components: {
        quillEditor
    },
    created() {
        this.getDept();
        this.getRoles();
    },
    beforeCreate() {
        that = this;
    },
    mounted: function () {
        this.setCJHeight();
    },
    methods: {
        gotolink: function (param1, param2) {
            //指定跳转地址
            this.$router.push({
                path: "/MoreDeviceInfo",
                query: {
                    id: param1,
                    source: param2
                },
            });
        },
        onEditorChange({
            editor,
            html,
            text
        }) {
            this.content = html;
        },
        setCJHeight() {
            this.$nextTick(() => {
                // 页面渲染完成后的回调
                var headerHeight = document.getElementsByClassName('content')[0].offsetHeight;
                this.leftHeight = headerHeight * 0.93 + 'px';
                this.leftTreeHeight = headerHeight * 0.85 + 'px';
            });
        },
        handleNodeClick(data, node, self) {
            var newdata = getchild(this.deptArr, [data.id], data.id);
            this.query.Field5 = newdata.join(',');
            this.getData();
        },
        saveEdit() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    var parentidPath = this.user.DeptIdTree;
                    this.user.DeptId = parentidPath[parentidPath.length - 1] + '';
                    this.isResouceShow = this.isResouceShow + 1;
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Account/UserAdd', this.user)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.deviceList.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.user = {};
                                } else {
                                    this.$notify.error(this.$t('pages.deviceList.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.deviceList.addError')));
                    } else {
                        this.$zybhttp
                            .post('Account/UserUpdate', this.user)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.deviceList.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.deviceList.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.deviceList.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async updateToken() {
            const resRefresh = await RefreshToken();
            if (resRefresh.status === 0) {
                localStorage.setItem('token', resRefresh.msg);
            }
        },
        getData() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.query.Field1 = userInfo.userType;
            this.query.Field2 = userInfo.id + '';
            this.query.Field3 = userInfo.realName;
            this.$zybhttp
                .post('Balance/GetList', this.query, {
                    // Field1: userInfo.userType,
                    // Field2: userInfo.id + '',
                    // Field5: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.isUseFt = x.isUse == '1';
                            x.isUseMonitor = x.isShowMonitor == '1';
                            return x;
                        }, []);
                        this.balances = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.deviceList.fetchError')));
        },
        getRoles() {
            // this.loading=true;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('role/GetList', {
                    Field5: userInfo.id + ''
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.id = x.id + '';
                            return x;
                        }, []);
                        this.roles = newdata;
                        roleArr = newdata;
                        var userDept = parseInt(userInfo.deptId);
                        var newdata = getchild(this.deptArr, [userDept], userDept);
                        this.query.Field5 = newdata.join(',');

                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.deviceList.fetchError')));
        },
        getAxiso() {
            this.$zybhttp
                .get('Account/UserDel?ids=1')
                .then((res) => {})
                .catch((err) => console.log(err, '网络异常！获取列表失败！'));
        },
        getDept() {
            var serach = {};
            this.$zybhttp
                .post('Dept/GetList', {
                    Field5: '1'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        this.deptArr = res.data.data.list;
                        var d = res.data.data.list;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1);
                        d = d.sort(SortField('sort', 'asc'));
                        var arr = [];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({
                                id: d[i].id,
                                pid: d[i].parentId,
                                value: d[i].id,
                                label: d[i].name
                            });
                        }
                        this.deptTree = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        handleEdit(id, row, source) {
            this.gotolink(row.id, source);

        },
        dbSelected(row) {
            this.user = row;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            if (userInfo.userType == row.UserType) {
                this.viewVisible = true;
                return;
            }
            this.user.id = row.id;
            this.editVisible = true;
            this.isadd = false;
            var arr = new Array();
            if (this.user.DeptId != '0') {
                var d = this.user.parentIdPath.split(',');
                var char = userInfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            arr.push(parseInt(this.user.DeptId));
            this.user.DeptIdTree = arr;
            this.headTitle = '修改用户信息';
            this.UpdateRoleAndDept = userInfo.loginId == row.LoginId;
        },
        handleShow(index, row) {
            this.user = row;
            this.viewVisible = true;
        },
        handleAdd() {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.user = {};
            this.isadd = true;
            let date = new Date();
            // this.user.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.user.CreateUserId = userinfo.loginId;
            this.user.ModifyUserId = userinfo.loginId;
            this.editVisible = true;
            this.headTitle = '新增用户信息';
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}

.el-button--small,
.el-button--small.is-round {
    padding: 9px 8px;
}

.el-main {
    color: #333;
    text-align: center;
    padding: 0px 0px 0px 15px;
}
</style><style>
.el-dialog__body {
    height: 55vh;
    overflow: hidden;
}

.el-tree-node.is-current>.el-tree-node__content {
    background-color: #dfe0e0 !important;
}

/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
